import type { AccountType } from '@dhl/mdp-api'
import type { Product, ProductGroup } from '~/common/model/capabilities'

// api/products
export type ProductDefinitionDto = {
  key: string
  label: string
  group?: ProductGroup
  code?: string
  menuCode?: string
  businessProduct?: boolean
  monoColloProduct?: boolean
  softwareCharacteristic?: string
}

export const getProductsByAccountType = (accountType: AccountType, products: Product[]) => {
  switch (accountType) {
    case 'Verlader':
      return []
    default:
      return products
  }
}
